import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './services/auth';


export const routes = [
  { path: '', redirectTo: 'super', pathMatch: 'full' },
  { path: 'super', loadChildren: './super/super.module#SuperModule',  canActivate: [AuthGuard] },
  { path: 'login', loadChildren: './login/login.module#LoginModule' },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
